if (!customElements.get("variant-selects")) {
    class VariantSelects extends HTMLElement {
        constructor() {
            super();

            let variantOptions,
                variantInputs = [];
            this.addEventListener("change", this.onVariantChange);

            this.variantsInputs = this.querySelectorAll("fieldset > input");
            this.optionName = this.querySelectorAll("fieldset > legend");

            /* stock counter block */
            this.availableVariants = document.querySelectorAll(
                "input.variant__configurable"
            );
            this.stockCounterContainer = document.querySelectorAll(
                ".stock__counter.configurable"
            );

            /* update selected variant stock status label on page refresh */
            this.getVariantData().find((variant) => {
                variantOptions = variant.options;

                this.variantsInputs?.forEach((item) => {
                    if (item.checked) variantInputs.push(item.value);
                });

                if (
                    variantInputs.length > 0 &&
                    this.containsOnly(variantInputs, variantOptions)
                )
                    this.showStockCounterConfigurableProducts(variant);
            });
        }

        containsOnly(array1, array2) {
            return array2.every((elem) => array1.includes(elem)); //return selected variant
        }

        onVariantChange() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, "", false);
            this.updatePickupAvailability();
            this.removeErrorMessage();

            if (!this.currentVariant) {
                this.toggleAddButton(true, "", true);
                this.setUnavailable();

                this.showStockCounterConfigurableProducts(!this.currentVariant);
            } else {
                this.updateMedia();
                this.updateURL();
                this.updateVariantInput();
                this.renderProductInfo();

                this.showStockCounterConfigurableProducts(this.currentVariant);
            }
        }

        markUnavailableVariant(currentVariant) {
            this.variantsInputs?.forEach((input) => {
                /* update Legend label to e.g - Color: {{ colorValue}} on the product page */
                if (input.checked) this.updateLegendLabel(input);

                this.options?.map((option, index) => {
                    if (
                        this.options[index] !== null &&
                        (currentVariant.available == "undefined" ||
                            !currentVariant.available)
                    )
                        input.classList.add("unavailable-option");
                    else input.classList.remove("unavailable-option");
                });
            });
        }

        setOptionName(name, pureName, input) {
            name.innerHTML =
                pureName +
                " " +
                '<span class="lighter _capitalize">' +
                input.value +
                "</span>";
        }

        updateLegendLabel(input) {
            this.optionName.forEach((name) => {
                let pureOptionName = name.innerText.split(" ")[0]; // get pure option name e.g. Color: red => return Color:

                if (
                    pureOptionName
                        .toLowerCase()
                        .indexOf(input.name.toLowerCase()) === 0
                )
                    setTimeout(() => {
                        this.setOptionName(name, pureOptionName, input);
                    });
            });
        }

        updateOptions() {
            this.options = Array.from(
                this.querySelectorAll("select"),
                (select) => select.value
            );
        }

        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options
                    .map((option, index) => {
                        return this.options[index] === option;
                    })
                    .includes(false);
            });
        }

        updateMedia() {
            if (!this.currentVariant || !this.currentVariant?.featured_media)
                return;
            const gallery = document.getElementById(
                `gallery-${this.dataset.section}`
            );

            if (!gallery) return;
            gallery.sliderItems.forEach((item, index) => {
                if (
                    item.dataset.mediaId ==
                    this.currentVariant.featured_media.id
                ) {
                    gallery.activateSlide(index);
                }
            });
        }

        updateURL() {
            if (!this.currentVariant || this.dataset.updateUrl === "false")
                return;
            window.history.replaceState(
                {},
                "",
                `${this.dataset.url}?variant=${this.currentVariant.id}`
            );
        }

        removeErrorMessage() {
            const section = this.closest("section");
            if (!section) return;

            const productForm = section.querySelector("product-form");
            if (productForm) productForm.handleErrorMessage();
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(
                `#product-form-${this.dataset.section}, #product-form-installment`
            );
            productForms.forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        updatePickupAvailability() {
            const pickUpAvailability = document.querySelector(
                "pickup-availability"
            );
            if (!pickUpAvailability) return;

            if (this.currentVariant?.available) {
                pickUpAvailability.fetchAvailability(this.currentVariant.id);
            } else {
                pickUpAvailability.removeAttribute("available");
                pickUpAvailability.innerHTML = "";
            }
        }

        renderProductInfo() {
            const ids = this.getUpdatable();

            fetch(
                `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
            )
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(
                        responseText,
                        "text/html"
                    );

                    ids.map((id) => {
                        const destination = document.getElementById(id);
                        const source = html.getElementById(id);

                        if (source && destination)
                            destination.innerHTML = source.innerHTML;
                        destination?.classList.remove("invisible");
                    });

                    this.toggleAddButton(
                        !this.currentVariant?.available,
                        window.variantStrings.soldOut
                    );
                });
        }

        toggleAddButton(disable = true, text, modifyClass = true) {
            const addButton = document
                .getElementById(`product-form-${this.dataset.section}`)
                ?.querySelector('[name="add"]');

            if (!addButton) return;

            if (disable) {
                addButton.setAttribute("disabled", true);
                if (text) addButton.querySelector(".text").textContent = text;
            } else {
                addButton.removeAttribute("disabled");
                addButton.querySelector(".text").textContent =
                    window.variantStrings.addToCart;
            }

            if (!modifyClass) return;
        }

        setUnavailable() {
            const addButton = document
                .getElementById(`product-form-${this.dataset.section}`)
                ?.querySelector('[name="add"]');
            if (!addButton) return;
            addButton.querySelector(".text").textContent =
                window.variantStrings.unavailable;
            document
                .getElementById(`price-${this.dataset.section}`)
                ?.classList.add("invisible");
        }

        getVariantData() {
            this.variantData =
                this.variantData ||
                JSON.parse(
                    this.querySelector('[type="application/json"]').textContent
                );
            return this.variantData;
        }

        getUpdatable() {
            var updatable = [];

            document
                .querySelectorAll('[data-updatable="true"]')
                .forEach((el) => {
                    el.id && updatable.push(el.id);
                });

            return updatable;
        }

        resetStockContainerInfo() {
            this.stockCounterContainer[0].dataset.stockQty = "";
            this.stockCounterContainer[0].innerHTML = "";
        }

        showStockCounterConfigurableProducts(currentVariant) {
            this.markUnavailableVariant(currentVariant);
            if (!this.stockCounterContainer.length) return;

            this.resetStockContainerInfo();

            let title = this.stockCounterContainer[0].dataset.title,
                inStock = this.stockCounterContainer[0].dataset.titleInStock,
                outOfStock =
                    this.stockCounterContainer[0].dataset.titleOutOfStock,
                thresholdQty =
                    this.stockCounterContainer[0].dataset.thresholdQty; // config option thresholdQty

            this.availableVariants.forEach((variant) => {
                /* if variant not available show Out of Stock label */
                if (!currentVariant.available) {
                    this.stockCounterContainer[0].dataset.stockQty =
                        variant.dataset.variantQty;

                    title = title.replace(
                        "Only <strong>X</strong> left",
                        outOfStock
                    );
                    this.stockCounterContainer[0].innerHTML = title;
                }

                if (
                    currentVariant.id == variant.dataset.variantId &&
                    parseInt(variant.dataset.variantQty) > 0
                ) {
                    if (
                        parseInt(variant.dataset.variantQty) >
                        parseInt(thresholdQty)
                    ) {
                        this.stockCounterContainer[0].dataset.stockQty =
                            variant.dataset.variantQty;
                        inStock = inStock.replace(
                            "{{ stock_qty }}",
                            variant.dataset.variantQty
                        );

                        title = title.replace(
                            "Only <strong>X</strong> left",
                            inStock
                        ); // In Stock X left
                        this.stockCounterContainer[0].innerHTML = title;
                    } else {
                        this.stockCounterContainer[0].dataset.stockQty =
                            variant.dataset.variantQty;

                        title = title.replace("X", variant.dataset.variantQty); // Only X left
                        this.stockCounterContainer[0].innerHTML = title;
                    }
                }
            });
        }
    }

    customElements.define("variant-selects", VariantSelects);

    class VariantRadios extends VariantSelects {
        constructor() {
            super();
        }

        updateOptions() {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            this.options = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll("input")).find(
                    (radio) => radio.checked
                ).value;
            });
        }
    }

    customElements.define("variant-radios", VariantRadios);
}
